import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import JobCard from "./JobCard";
import { Sparkles, ArrowRight } from "lucide-react";

export default function RecommendedRow() {
  const [data, setData] = useState(null);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    api.get("/jobs/recommended?limit=6")
      .then((r) => setData(r.data))
      .catch(() => setVisible(false));
  }, []);

  if (!visible || !data || !data.jobs?.length) return null;

  return (
    <section className="border-b border-zinc-800 py-16 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-end justify-between mb-8">
          <div>
            <div className="text-xs font-mono-alt uppercase text-yellow-500 tracking-widest mb-2 flex items-center gap-2">
              <Sparkles size={14} /> For You
            </div>
            <h2 className="font-display text-5xl md:text-6xl uppercase leading-none">{data.reason}</h2>
          </div>
          <Link to="/jobs" data-testid="recommended-view-all" className="hidden md:flex text-sm uppercase tracking-wider text-zinc-500 hover:text-white items-center gap-2">
            View All <ArrowRight size={14} />
          </Link>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
          {data.jobs.map((j, i) => (<JobCard key={j.id} job={j} index={i} />))}
        </div>
      </div>
    </section>
  );
}
